import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { ChannelSchema } from 'types';

export type ChannelState = ChannelSchema & {
  subscribersCount: number;
  finishedEventsCount: number;
};

export type ChannelsState = {
  [id: string]: ChannelState;
};

const initialState: ChannelsState = {};

export const channelsSlice = createSlice({
  name: 'channels',
  initialState,
  reducers: {
    setChannel: (state, action: PayloadAction<ChannelSchema>) => ({
      ...state,
      [action.payload.id]: {
        ...state[action.payload.id],
        ...action.payload,
        subscribersCount: state[action.payload.id]?.subscribersCount || 0,
        finishedEventsCount: state[action.payload.id]?.finishedEventsCount || 0
      }
    }),
    setSubscribersCount: (state, action: PayloadAction<{ channelId: string; subscribersCount: number }>) => ({
      ...state,
      [action.payload.channelId]: {
        ...state[action.payload.channelId],
        subscribersCount: action.payload.subscribersCount
      }
    }),
    setFinishedEventsCount: (state, action: PayloadAction<{ channelId: string; finishedEventsCount: number }>) => ({
      ...state,
      [action.payload.channelId]: {
        ...state[action.payload.channelId],
        finishedEventsCount: action.payload.finishedEventsCount
      }
    })
  }
});

export const channelsReducer = channelsSlice.reducer;
export const channelsActions = {
  ...channelsSlice.actions
};
